import type { IconName, IconVariant } from '~/components/Icon';
import { NAVIGATION_PERMISSIONS } from '~/lib/navigationPermissions';
import type { HasPermissionFunction } from '~/modules/auth';
import { type BrandType } from '~/modules/branding/types';

interface NavItem {
  to: string;
  icon: IconName;
  iconVariant?: IconVariant;
  label: string;
  brands?: BrandType[];

  /**
   * Additional routes that will be considered as active when the current route matches.
   */
  matchRoutes?: RegExp[];
  title?: string;
  permission?: (
    hasPermission: HasPermissionFunction,
    context?: Record<string, unknown>,
  ) => boolean;
}

export const SIDEBAR_NAV_ITEMS: NavItem[] = [
  {
    to: '/',
    icon: 'list-music',
    label: 'dashboard',
    title: 'dashboard',
    brands: ['ADA'],
    matchRoutes: [/release\/+/],
  },
  {
    to: '/release-clinic',
    icon: 'truck-medical',
    label: 'releaseClinic',
    title: 'releaseClinic',
    permission: NAVIGATION_PERMISSIONS.RELEASE_CLINIC,
    brands: ['ADA'],
  },
  {
    to: '/video-management',
    icon: 'clapperboard-play',
    label: 'video',
    title: 'video',
    permission: NAVIGATION_PERMISSIONS.VIDEO_MANAGEMENT,
    brands: ['ADA'],
  },
  {
    to: '/reports',
    icon: 'chart-mixed',
    label: 'exports',
    title: 'exports',
    permission: NAVIGATION_PERMISSIONS.REPORTS,
    brands: ['ADA'],
    matchRoutes: [/report/, /exports/],
  },
  {
    to: '/platform/settings',
    icon: 'gear',
    label: 'settings',
    title: 'settings',
    permission: NAVIGATION_PERMISSIONS.COOP_SETTINGS,
    brands: ['ADA'],
  },
  {
    to: '/settings',
    icon: 'user-gear',
    label: 'settingsNew',
    title: 'settingsNew',
    permission: NAVIGATION_PERMISSIONS.SETTINGS,
    brands: ['ADA'],
  },

  {
    to: '/',
    icon: 'home',
    iconVariant: 'light',
    label: 'wmgHome',
    title: 'wmgHome',
    brands: ['WMG'],
  },
  {
    to: '/roster',
    icon: 'user-music',
    iconVariant: 'light' as IconVariant,
    label: 'roster',
    title: 'roster',
    brands: ['WMG'],
  },
  {
    to: '/label',
    icon: 'chart-line',
    iconVariant: 'light',
    label: 'labelPerformance',
    title: 'labelPerformance',
    brands: ['WMG'],
  },
  {
    to: '/catalog',
    icon: 'album-collection',
    iconVariant: 'light',
    label: 'catalog',
    title: 'catalog',
    brands: ['WMG'],
  },
  {
    to: '/marketing',
    icon: 'calendar',
    iconVariant: 'light',
    label: 'marketing',
    title: 'marketing',
    brands: ['WMG'],
  },
  {
    to: '/data',
    icon: 'chart-mixed',
    iconVariant: 'light',
    label: 'data',
    title: 'data',
    brands: ['WMG'],
  },
  {
    to: '/distribution',
    icon: 'list-music',
    iconVariant: 'light',
    label: 'distribution',
    title: 'distribution',
    brands: ['WMG'],
  },
  {
    to: '/release-management',
    icon: 'list-music',
    iconVariant: 'light',
    label: 'release-management',
    title: 'release-management',
    permission: NAVIGATION_PERMISSIONS.WMG_RELEASE_MANAGEMENT,
    brands: ['WMG'],
  },
  {
    to: '/publishing',
    icon: 'file-music',
    iconVariant: 'light',
    label: 'publishing',
    title: 'publishing',
    brands: ['WMG'],
  },
  {
    to: '/finance',
    icon: 'circle-dollar',
    iconVariant: 'light',
    label: 'finance',
    title: 'finance',
    brands: ['WMG'],
  },
];
